import React, { useState, useEffect, useRef, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setClientBranchesRetrieveActions,
  getSideBarfilesActions,
  SetVerifiedUserActions,
  SetEmployeeProfileDetailsID,
  SetStatusBTN,
  SetISPendingDetails,
  SettheActiveTabsActionClientDetails, ///---To---Make---Active--------------------------------
  setEditableActions, ///readable
  StetheAttendanceExportActions,
  sethtmlformatpdfdownoadActions, ////---pdf----formats---------------
} from "../../../Redux/Slice";
import Select from "react-select";
import correctIcons from "../../../Assets/AppComponent/icons/Group 359.svg";
import Pending from "../../../Assets/AppComponent/icons/Group 145.svg";
import houseKeeping from "../../../Assets/AppComponent/icons/Role/Union.png";
import Regionicons from "../../../Assets/AppComponent/icons/Locationicons/Layer_1 .png";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import empployeeIcons from "../../../Assets/AppComponent/icons/Employee/Group 349.png";
import { useNavigate } from "react-router-dom";
import MotionPhotosAutoIcon from "@mui/icons-material/MotionPhotosAuto";
import Pendingimg from "../../../Assets/AppComponent/icons/Group 145.svg";
import { DateRangePicker } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import ReactTable from "../../AppComponent/Table";
import Delete from "../../AppComponent/Popup/Delete";
import "../../../StyleSheet/MainComponent/Shift/Shifts.scss";
import "../../../StyleSheet/MainComponent/Client/ClientDetails.scss";
import profile2 from "../../../Assets/AppComponent/Profile/profile2.png";
import { el, tr } from "date-fns/locale";
import { NavLink } from "react-router-dom";
import { TextField } from "@mui/material";
// import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";

import swal from "sweetalert2";
import Swal from "sweetalert2";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import ReactDOMServer from "react-dom/server";
import CalenderPopup from "./CalenderPopup";
import _ from "lodash";
import BackImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";
import AttendanceExportImg from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-08.svg";

const Profile = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );

  const Swal = require("sweetalert2");

  const navigate = useNavigate();
  ///-------------------------Shift----Functionality
  const [currentPageShift, setCurrentPage] = useState(1);
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);

  ////---------------------------Verified ---emplyees
  const [Employeesdata, setEmployeeDatas] = useState([]);
  const [DeletePopup, setDeletepopup] = useState(false);
  const [DeleteId, setDeleteEmployeeID] = useState();
  const [EditPopupCall, setEditPopup] = useState(false);

  const [dtpageindexemp, setdtPageindexemp] = useState(1);
  const [dtpagesizeemp, setdtPagesizeemp] = useState(20);
  const [pageSizeemp, setPageSizeemp] = useState(10);
  const [newpagesemp, setNewpageemp] = useState(1);
  const [searchemp, setsearchEmp] = useState("");
  const [EmpDAta, setEmpdatas] = useState([]);
  const [currentPageemp, setCurrentPageemp] = useState(1);

  const [search, setsearch] = useState("");
  const [newpages, setNewpage] = useState(1);
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const [Counts, setCount] = useState(1);
  const [getidforupload, setidforuploaddata] = useState({
    client_id: "",
    user_id: "",
  });
  const [OldEmp, setOldEMp] = useState({
    label: "Current employee",
    value: false,
  });

  const oldemloyeeOptions = [
    {
      value: true,
      label: "Old employee",
    },
    {
      value: false,
      label: "Current employee",
    },
  ];
  const [sno, setsno] = useState(0);

  const [oldemplo, setoldemp] = useState({ old_employee: false });
  const HandleOldemployee = (e) => {
    setOldEMp(e);
    if (e != null) {
      setoldemp({
        ...oldemplo,
        old_employee: e.value,
      });
    }
  };

  ///---for dispatch the ,   tab number as 2 bacuses , right now it have to call defualtly
  useEffect(() => {
    dispatch(SettheActiveTabsActionClientDetails(2));
  }, []);

  ///--------------------------------------------
  const getCurrentMonthStartAndEndDate = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    const firstDateOfMonth = new Date(currentYear, currentMonth - 1, 1);
    const lastDateOfMonth = new Date(currentYear, currentMonth, 0);

    const startDatemon = `${currentYear}-${String(currentMonth).padStart(
      2,
      "0"
    )}-${String(firstDateOfMonth.getDate()).padStart(2, "0")}`;
    const endDatemon = `${currentYear}-${String(currentMonth).padStart(
      2,
      "0"
    )}-${String(lastDateOfMonth.getDate()).padStart(2, "0")}`;

    return {
      startDatemon,
      endDatemon,
    };
  };

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    ///  console.log(arg, "args");
    setdtPageindex(arg);
  };

  var { startDatemon, endDatemon } = getCurrentMonthStartAndEndDate();

  const [data, setdata] = useState({
    from_date: startDatemon,
    to_date: endDatemon,
    range: false,
    base_type: "day",
  });

  const Options = [
    {
      id: 1,
      value: "day",
      label: "DAY",
    },
    {
      id: 2,
      value: "time",
      label: "TIME",
    },
  ];

  const HandleChanges = (e) => {
    //    console.log(e.target.value, "sdfsdgfweifi");

    setdata({ ...data, base_type: e.target.value });
  };

  // const [startDate, setStartDate] = useState(null);
  // const [endDate, setEndDate] = useState(null);
  const [focusedInput, setFocusedInput] = useState(null);

  const [selectedDates, setSelectedDates] = useState([]);
  const [datestae, setdatest] = useState(false);
  const formattedDates =
    selectedDates != null &&
    selectedDates.map((date) => {
      const isoString = date.toISOString();
      return isoString.substring(0, 10);
    });

  // const handleDateChange = (e) => {
  //   if (e != null) {
  //     setdatest(true);
  //     setSelectedDates(e);
  //     e.forEach((newValue) => {
  //       const tzoffset = new Date().getTimezoneOffset() * 60000;
  //       const localISOTime = new Date(newValue - tzoffset)
  //         .toISOString()
  //         .slice(0, -1);
  //       // handle the start and end dates here
  //     });
  //   }
  // };

  useEffect(() => {
    if (datestae) {
      setdata({
        ...data,
        from_date: formattedDates[0],
        to_date: formattedDates[1],
        range: true,
      });
    }
  }, [selectedDates]);

  const handleFocusChange = (focusedInput) => {
    setFocusedInput(focusedInput);
  };

  ////--------------------------Emp Inquriy----------FUnctionality
  const [dtpageindexEMp, setdtPageindexEMP] = useState(1);
  const [dtpagesizeEmp, setdtPagesizeEMp] = useState(10);
  const [pageSizeEMP, setPageSizeEMp] = useState(10);
  const [searchEmp, setsearchEMP] = useState("");
  const [newpagesEmp, setNewpageEMP] = useState(1);
  const [currentPageEmp, setcurrentPageemp] = useState(1);

  const [DeleteIDEMP, SetDeleteEmpID] = useState("");
  const [DeleteEmpPOPUP, setDeletePOPUPEMp] = useState(false);
  const [EditIdEmp, setEditId] = useState("");
  const [EditPopupEmp, setsetEditEmpPOPUP] = useState(false);
  const [EmpCreatepopup, setCreateEmpPopup] = useState(false);
  const [MakeCreateEmp, setCreateBarStatus] = useState(true);

  ///-----Client---Branch---Edit
  const [BranchEditid, setEditBranchID] = useState("");
  const [EditBranchPOPUP, setEditPopupBranch] = useState(false);
  useEffect(() => {
    if (state.ClientBranchIDs.clientBranchEditView != undefined) {
      setEditBranchID(state.ClientBranchIDs.clientBranchEditView);
    }
  }, [state.ClientBranchIDs.clientBranchEditView]);

  useEffect(() => {
    if (state.ClientBranchIDs.clientBranchEditView != undefined) {
      const payload = {
        EditId: state.ClientBranchIDs.clientBranchEditView,
      };
      dispatch(setClientBranchesRetrieveActions(payload));
    }
    //console.log(state.BranchRetrieve.BranchesRetrieve, "wetgesdv");
  }, [state.ClientBranchIDs.clientBranchEditView]);

  function Counting(value) {
    setCount(value);
    return Counting;
  }

  function capital_letter(str) {
    str = str.split(" ");

    for (var i = 0, x = str.length; i < x; i++) {
      str[i] = str[i][0].toUpperCase() + str[i].substr(1);
    }
    // console.log(str, "strrs");
    return str.join(" ");
  }

  ///-------------_Verified---________Employees-------------------------

  useEffect(() => {
    if (state.clientDetailsCall.ActiveClinetTabs == 2) {
      const payload = {
        search: searchemp,
        page_size: "20",
        page: dtpageindexemp,
        client_id: state.ClientBranchIDs.clientBranchEditView,
        //client_id: state.ClientBranchIDs.ClientBranchID,
        old_employee: oldemplo.old_employee,
      };
      dispatch(SetVerifiedUserActions(payload));
    }
  }, [state.clientDetailsCall.ActiveClinetTabs, oldemplo, dtpageindexemp]);

  useEffect(() => {
    if (state.VerifiedUsers.VerifiedUsersData != undefined) {
      setEmpdatas(state.VerifiedUsers.VerifiedUsersData);
    }
    // console.log(
    // state.VerifiedUsers.VerifiedUsersData.inquiry_data,
    // EmpDAta,
    // "isfadoi9opj"
    // );
  }, [state.VerifiedUsers.VerifiedUsersData]);

  // const attendanceexportEmp = (e, statement, values) => {
  //   Swal.fire({
  //     title: `Are you sure, do you want to export the attendance  ${
  //       statement ? "based on this month to  end of the  month" : ""
  //     }?`,
  //     text: "You won't be able to revert this",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#f26639",
  //     cancelButtonColor: "#F69338",
  //     confirmButtonText: "Yes, Export it!",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       const payloads = {
  //         export_type: "employee",
  //         client_id: "",
  //         user_id: values.user_id,
  //         data: values.data,
  //       };
  //       dispatch(StetheAttendanceExportActions(payloads));
  //     } else if (result.dismiss === Swal.DismissReason.cancel) {
  //       Swal.close();
  //     }
  //   });
  // };

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleDateChange = (date) => {
    if (!startDate || (startDate && endDate)) {
      // Set start date if it's not set or if both dates are already selected
      setStartDate(date);
      setEndDate(null);
    } else if (date >= startDate) {
      // Set end date if selected date is after start date
      setEndDate(date);
    } else {
      // Reset selection if selected date is before start date
      setStartDate(date);
      setEndDate(null);
    }
  };

  const datePickerContainer = (
    <div>
      {/* <DateCalendar
      // value={value}
      // onChange={(newValue) => setValue(newValue)}
      // showDaysOutsideCurrentMonth
      // displayWeekNumber
      // slots={{ day: Day }}
      // slotProps={{
      //   day: (ownerState) =>
      //     ({
      //       selectedDay: value,
      //       hoveredDay,
      //       onPointerEnter: () => setHoveredDay(ownerState.day),
      //       onPointerLeave: () => setHoveredDay(null),
      //     }) as any,
      // }}
      /> */}
    </div>
  );

  // Convert JSX elements to HTML string
  const htmlString = ReactDOMServer.renderToString(datePickerContainer);

  const attendanceexportEmp = (e, statement, values, dispatch) => {
    Swal.fire({
      title: `Export Attendance`,
      html: htmlString, // Pass the rendered HTML string to html
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Export",
      cancelButtonText: "Cancel",
      showLoaderOnConfirm: true,
      preConfirm: () => {
        // Handle export action here with selected date range
        const payloads = {
          export_type: "employee",
          client_id: "",
          user_id: values.user_id,
          data: values.data,
          startDate: startDate.toISOString(), // Convert to ISO format or modify as needed
          endDate: endDate.toISOString(),
        };
        return dispatch(StetheAttendanceExportActions(payloads));
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Exported!", "Attendance exported successfully.", "success");
      }
    });
  };

  const columnsemp = useMemo(
    () => [
      {
        Header: "Tnx Id",
        accessor: "",
        Cell: (row) => {
          if (row.row.original.user_id.id != undefined && row.row.original.user_id.id != null) {
            const userId = row.row.original.user_id.id;
            const lastFourDigits = userId.slice(-6);
            return <p>{lastFourDigits}</p>;
          }
        },
      },


      {
        Header: " Name",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <div className="UserNames" style={{ cursor: "pointer", }}>

                <div className="">
                  <span>{row.row.original.user_id.first_name}</span>
                </div>
              </div>
            </>
          );
        },
      },
      {
        Header: "Role",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {row.row.original.user_id.user_role.role != undefined ? (
                <div className="UserName">

                  <span>{row.row.original.user_id.user_role.role}</span>
                </div>
              ) : (
                <div className="UserName">
                  <span>---</span>
                </div>
              )}
            </>
          );
        },
      },

      {
        Header: "Created date",
        accessor: "",
        Cell: (row) => {
          const dateString = row.row.original.created_at;
          const dateObject = new Date(dateString);
          const hours = dateObject.getHours();
          const minutes = dateObject.getMinutes();
          const seconds = dateObject.getSeconds();
          const amOrPm = hours >= 12 ? "PM" : "AM";
          const twelveHourFormat = hours % 12 || 12;

          const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

          const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

          return (
            <>
              <p
              // data-tooltip-id="Name-ToolTips"
              // data-tooltip-content={`${formattedTime}`}
              >
                {`${row.row.original.created_at.slice(0, 10) + "  " + formattedTime
                  }`}
              </p>
            </>
          );
        },
      },
      {
        Header: "Verification",
        accessor: "",
        Cell: (row) => {
          const [showTooltip, setShowTooltip] = useState(false);

          return (
            <>
              <>
                <div className="StatusList">
                  <img src={correctIcons} />
                  <span>Approve</span>
                  <span className="AllformExcelclient">
                    {
                      !oldemplo.old_employee &&
                      row.row.original != undefined &&
                        row.row.original.user_id != undefined &&
                        row.row.original.user_id != null ? (
                        <img
                          src={AttendanceExportImg}
                          style={{ fontSize: "27px" }}
                          onClick={(e) => {
                            setEditId(row.row.original.user_id.id);
                            setsetEditEmpPOPUP(true);
                          }}
                          onMouseEnter={() => setShowTooltip(true)}
                          onMouseLeave={() => setShowTooltip(false)}
                        />
                      ) : // </button>
                        null}
                    {
                      !oldemplo.old_employee &&
                      showTooltip && (
                        <div className="custom-tooltip" style={{ left: "22%" }}>
                          {"Attendance export"}
                        </div>
                      )}
                    





                  </span>
                </div>
              </>
            </>
          );
        },

        //
      },
    ],
    [sno]
  );
  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        const payload = {
          search: e,
          page_size: dtpagesizeemp,
          client_id: state.ClientBranchIDs.clientBranchEditView,
          page: 1,
          old_employee: oldemplo.old_employee,
        };
        dispatch(SetVerifiedUserActions(payload));
      }, 500),
    []
  );

  function tochangeEmp(e) {
    // console.log("ee", e);
    setsearchEmp(e);
    debouncedSearch(e);
    // if (e.trim() != undefined && e.trim() !== "") {
    //   const payload = {
    //     search: e.trim(),
    //     page_size: dtpagesizeemp,
    //     client_id: state.ClientBranchIDs.clientBranchEditView,
    //     page: 1,
    //     old_employee: oldemplo.old_employee,
    //   };
    //   // console.log(e, "testnew")
    //   dispatch(SetVerifiedUserActions(payload));
    // }
    // if (e == "" || searchemp == "") {
    //   const payload = {
    //     search: "",
    //     page_size: dtpagesizeemp,
    //     page: 1,
    //     client_id: state.ClientBranchIDs.clientBranchEditView,
    //     old_employee: oldemplo.old_employee,
    //   };
    //   dispatch(SetVerifiedUserActions(payload));
    // }
  }

  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const pagesizeemp = (arg) => {
    setdtPagesizeemp(arg);
  };
  const pageindexemp = (arg) => {
    //  console.log(arg, "args");
    setdtPageindexemp(arg);
  };



  const handleNextemp = (next) => {

    setdtPageindexemp(next + 1);

  };

  const handlePreviousemp = (previous) => {
    setdtPageindexemp(previous);

  };

  const GotoEnteredPage = (gotopage) => {
    setdtPageindexemp(gotopage)
  }

  //-------------------Employee----Forms----Details
  // const handleEmployeeDetails = (id) => {
  // if (!oldemplo.old_employee) {
  // console.log(id.user_id.id, "isfsd");
  // dispatch(SetEmployeeProfileDetailsID(id.user_id.id));
  // dispatch(SetISPendingDetails(id.is_pending));
  // dispatch(setEditableActions(1)); /// to---make ---as 0------readable---only
  // dispatch(SetStatusBTN(true));
  // navigate("/employeeprofile");
  // }
  // };
  //
  //

  const attendanceexport = (e, statement, values) => {
    console.log(values, statement, e, "auysfdyasdlas");
    Swal.fire({
      title: `Are you sure, do you want to export the attendance  ${statement ? "based on this month to end of the  month" : ""
        }?`,
      text: "You won't be able to revert this",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#f26639",
      cancelButtonColor: "#F69338",
      confirmButtonText: "Yes, Export it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const payloads = {
          export_type: values,
          client_id: state.ClientBranchIDs.clientBranchEditView,
          user_id: "",
          data: data,
        };
        dispatch(StetheAttendanceExportActions(payloads));
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.close();
      }
    });
  };

  return (
    <>
      <div className="Details">
        <div className={stateDisplay ? " POPUP" : "outerPOPUP"}>
          <div className="Header-Details ClientBranch row">
            <div
              // className="InnerUsers"
              class="col-sm-7 auto"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "flex-start",
              }}
            >
              <h3>Branch Employees Profile</h3>

              {/* <ul class="breadcrumb">
                <li class="breadcrumb-item">
                  <NavLink
                    style={{ textDecoration: "none", color: "#333333" }}
                    to={"/report"}
                    onClick={(e) => {
                      dispatch(getSideBarfilesActions("Attendance Report"));
                    }}
                  >
                    Attendance Report
                  </NavLink>
                </li>

                <li class="breadcrumb-item active">
                  Branch Employees Profile{" "}
                </li>
              </ul> */}
            </div>
          </div>

          <div className="row Filters ButtonPrevious">
            <div className="col">
              <button
                className="btn BackImga"
                onClick={(e) => {
                  navigate("/report");
                }}
              >
                <img className="PreviousPages" src={BackImage} />
                <span></span>
              </button>
            </div>
          </div>

          <div className="row ProfileFile">
            <div className="col-md-12">
              <div className="row">
                {/* <div className="ListedLinks">
                    <ul>
                      <li>
                       <a href={state.ClientBranchIDs.NavigateCAll}>{state.ClientBranchIDs.NavigateCAll}  </a>
                        </li>
                        {/* <li>
                       <a href={state.SideBarFiles.SideBarFile}>{state.SideBarFiles.SideBarFile} </a>
                        </li> */}
                {/* </ul>
                    </div> */}
              </div>
              <div class="profile-header">
                <div
                  class="row  align-items-center"
                  style={{ padding: "2.5rem" }}
                >
                  <div class="col-auto profile-image">
                    <a>
                      <div className="BranchLogo">
                        <img class="" alt="User Image" src={profile2} />
                      </div>
                    </a>
                  </div>
                  <div class="col ml-md-n2 profile-user-info AttendanceProfile">
                    {state.BranchRetrieve.BranchesRetrieve.client_name !=
                      undefined ? (
                      <h4
                        class="user-name mb-0"
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "flex-start",
                          gap: "10px",
                        }}
                      >
                        {/* {state.BranchRetrieve.BranchesRetrieve.client_name.toUpperCase()} */}
                        {capital_letter(
                          state.BranchRetrieve.BranchesRetrieve.client_name
                        )}
                      </h4>
                    ) : null}
                    {state.BranchRetrieve.BranchesRetrieve != undefined &&
                      state.BranchRetrieve.BranchesRetrieve.zone_id !=
                      undefined &&
                      state.BranchRetrieve.BranchesRetrieve.zone_id != null ? (
                      <p
                        className="superViorName"
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "20px",
                          color: "#EF5239",
                          fontSize: "19px",
                          marginTop: "12px",
                        }}
                      >
                        {
                          state.BranchRetrieve.BranchesRetrieve.zone_id
                            .zone_name
                        }
                      </p>
                    ) : null}
                  </div>
                  <div
                    class="col-auto profile-btn"
                    style={{ display: "flex", justifyContent: "space-between" }}
                  ></div>
                </div>

                <div className="profile-menu TabsStartHead">
                  <div className="innerTabs">
                    <ul class="nav nav-tabs" id="ex1" role="tablist">
                      <li class="nav-item" role="presentation">
                        <button
                          //  class="nav-link"
                          className={`  nav-link   ${state.clientDetailsCall.ActiveClinetTabs == 2
                              ? "active "
                              : ""
                            }`}
                          id="ex3-tab-2"
                          data-bs-toggle="tab"
                          href="#ex3-tabs-2"
                          role="tab"
                          aria-controls="ex3-tabs-2"
                          aria-selected="false"
                          onClick={(e) => {
                            Counting(2);
                            dispatch(SettheActiveTabsActionClientDetails(2));
                          }}
                        >
                          Onboard Employees
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="card BeforeTabs ">
                <div className="card-body innerBody">
                  <div className="TabsStart">
                    <div className="row">
                      <div className="col-12">
                        <div className="card">
                          <div className="card-body DetailsPart">
                            <div class="tab-content" id="ex2-content">
                              {/* ////-------------EMP---INQURIY----------------- */}
                              <div
                                className={`  tab-pane fade show   ${state.clientDetailsCall.ActiveClinetTabs == 2
                                    ? "active "
                                    : ""
                                  }`}
                                id="ex3-tabs-2"
                                role="tabpanel"
                                aria-labelledby="ex3-tab-2"
                              >
                                {EmpDAta != undefined ? (
                                  <div
                                    style={{
                                      padding: "0px",
                                    }}
                                  >
                                    <ReactTable
                                      data={EmpDAta}
                                      columns={columnsemp}
                                      totalItems={
                                        state.VerifiedUsers.Total_Count
                                      }
                                      currentPage={currentPageemp}
                                      // onPageChange={handlePageChange}
                                      onChange={tochangeEmp}
                                      setCurrentPage={setCurrentPageemp}
                                      pagesize={pagesizeemp}
                                      onPrevious={handlePreviousemp}
                                      onNextpage={handleNextemp}
                                      GotoEnteredPage={GotoEnteredPage}

                                      dtpagesize={dtpagesizeemp}
                                      dtpageindex={dtpageindexemp}
                                      pageindex={pageindexemp}
                                      datacount={
                                        state.VerifiedUsers.Total_Count
                                      }
                                      MakeCreate={false}
                                      // ViewParts={(e) => {
                                      //   handleEmployeeDetails(e);
                                      // }}
                                      OldEmployeFilters={true}
                                      oldemloyeeOptions={oldemloyeeOptions}
                                      OldEmp={OldEmp}
                                      Filter={true}
                                      HandleOldemployee={HandleOldemployee}
                                      setsno={setsno}
                                      sno={sno}
                                      id={"spe"}
                                    />
                                  </div>
                                ) : (
                                  <div className="row d-flex justify-content-center align-items-center">
                                    <div className="col-12 text-center">
                                      <p
                                        style={{
                                          height: "100%",
                                          position: "relative",
                                          top: "11px",
                                        }}
                                      >
                                        No data
                                      </p>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <>
        <Tooltip
          id="Name-ToolTips"
          className="ReactTooltip"
          // noArrow
          BottomRight
          style={{ zIndex: 9999 }} // Adjust the value as needed
        />
        {/* <Tooltip id="Name-ToolTips" zIndex={999} /> */}
      </>

      {EditIdEmp != undefined && currentPageemp != undefined && EditPopupEmp ? (
        <CalenderPopup
          show={EditPopupCall}
          setShow={setsetEditEmpPOPUP}
          EditID={EditIdEmp}
          currentPage={dtpageindex}
          counts={2}
        />
      ) : null}
    </>
  );
};

export default Profile;
